export type SpotCategory = string;

export interface Spot {
  spot_id: string;
  kind?: "spot" | "venue";
  category: SpotCategory;
  name_ar: string;
  name_en?: string;
  description_ar?: string;
  governorate: string;
  area?: string;
  address?: string;
  lat: number;
  lng: number;
  gallery: string[];
  hours_ar?: string;
  active: boolean;
  directions_url: string;
  rating_avg?: number | null;
  rating_count?: number;
  distance_km?: number;
}

export interface SpotReview {
  review_id: string;
  spot_id: string;
  author: string;
  rating: number;
  tip: string;
  status: "pending" | "approved" | "rejected";
  created_at: string;
  reject_reason?: string | null;
  spot_name_ar?: string;
}

export const spotShareLink = (id: string) => `${window.location.origin}/api/share/spots/${id}`;
